import {ReactNode} from 'react';
import * as css from './SummaryCard.css';
import GenericPieChart from '../../../../genericPieChart/GenericPieChart';
import {COLORS} from '../../colors';

type TProps = {
    title: string;
    titleHelper?: ReactNode;
    body: ReactNode;
    segments: {value: number; color: string}[];
    center: ReactNode;
    sub: ReactNode;
    wide?: boolean;
};

function SummaryCard({title, titleHelper, body, segments, center, sub, wide}: TProps) {
    const chartData = segments.some(s => s.value > 0) ? segments : [{value: 1, color: COLORS.rest}];
    return (
        <css.card $wide={wide}>
            <css.cardText $wide={wide}>
                <css.cardTitle>{title}{titleHelper}</css.cardTitle>
                {body}
            </css.cardText>
            <css.cardChart>
                <GenericPieChart
                    data={chartData}
                    dataKey="value"
                    halfCircle
                    radius={{innerRadius: 65, outerRadius: 72}}
                    paddingAngle={0}
                    cornerRadius={4}
                    inlineRect={<><css.donutValue>{center}</css.donutValue><css.donutSub>{sub}</css.donutSub></>}
                />
            </css.cardChart>
        </css.card>
    );
}
export default SummaryCard;
